export default {
  brand: state => state.brand,
  brands: state => state.brands,
  pageSize: state => state.pageSize,
  searchTerm: state => state.searchTerm,
  retrospectiveDay: state => state.retrospectiveDay,
  filterOptions: state => state.filterOptions,
  filterBy: state => state.filterBy,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  preferences: state => state.preferences,
  franchisees: state => state.franchisees,
  shops: state => state.shops
}



// WEBPACK FOOTER //
// ./src/store/modules/brands/getters.js